import axios, { AxiosRequestConfig } from 'axios';
import { JournalEntry } from '../types/journal';

const API_BASE_URL = `${import.meta.env.VITE_API_URL}/api/journal`;

export const journalService = {
    async getAllEntries() {
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        const response = await axios.get(`${API_BASE_URL}`, { headers });
        return response.data;
    },

    async createEntry(entry: Omit<JournalEntry, 'id'>) {
        console.log(entry);
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        const response = await axios.post(`${API_BASE_URL}`, entry, { headers });
        return response.data;
    },

    async updateEntry(id: string, entry: Partial<JournalEntry>) {
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        const response = await axios.put(`${API_BASE_URL}/${id}`, entry, { headers });
        return response.data;
    },

    async deleteEntry(id: string) {
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        await axios.delete(`${API_BASE_URL}/${id}`, { headers });
    },

    async getEntry(id: string) {
        const headers: AxiosRequestConfig['headers'] = {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        const response = await axios.get(`${API_BASE_URL}/${id}`, { headers });
        return response.data;
    }
};